import { TimeWindow } from '../types/time-window.type';

// Top-N topics shown in the Intelligence table.
export const INTELLIGENCE_TOP_LIMIT = 5;

// Questions loaded per page in the Intelligence View modal. The modal pages
// through every question of the topic in the window; a page keeps each request
// small because every row is a full ~22 KB llm_usages document read.
export const INTELLIGENCE_QUESTIONS_PAGE_SIZE = 50;

// Default Intelligence (and What's-changed) time window. Typed as a bounded
// window so it is always valid as a key in INTELLIGENCE_WINDOW_DAYS.
export const DEFAULT_INTELLIGENCE_WINDOW: Exclude<
  TimeWindow,
  TimeWindow.AllTime
> = TimeWindow.Last7Days;

// Number of days each bounded Intelligence window spans. AllTime is excluded
// because it has no fixed span - use timeWindowToRange for the actual range.
export const INTELLIGENCE_WINDOW_DAYS: Record<
  Exclude<TimeWindow, TimeWindow.AllTime>,
  number
> = {
  [TimeWindow.Last24Hours]: 1,
  [TimeWindow.Last7Days]: 7,
  [TimeWindow.Last30Days]: 30,
  [TimeWindow.Last90Days]: 90,
};
